// Shared eligibility for the FCC certificate subscription offering. Applies to
// Certificates Subscriptions in general — the CM entry-point experiment, the HP
// entry-point experiment, and the core subscription logic (LP / catalog).
//
// - Enterprise users are also excluded from
// the subscription offering, but that is a per-user constraint handled
// differently on each surface (GrowthBook targeting server-side for the CM
// entry-point experiment; `useExperience` / offer eligibility for the
// subscription LP), so it is intentionally not part of this predicate.
import { NVIDIA_CERT_SLUG } from 'pages/certificates/common/certSlugs'

// Certs excluded from the subscription offering (the NVIDIA partnership cert).
export const EXCLUDED_SUBSCRIPTION_CERT_SLUGS = new Set([NVIDIA_CERT_SLUG])

// Painted-door pages are placeholder certs with no real product/offer, so they
// are excluded from the subscription offering too. `isPaintedDoor` is passed in
// (resolved server-side) rather than derived here: the check would otherwise
// need `isPaintedDoorSlug`, which pulls the large painted-door catalog into this
// client-shared module's bundle.
export const isCertEligibleForSubscription = (
  slug: string | undefined,
  isPaintedDoor = false,
) => !isPaintedDoor && !EXCLUDED_SUBSCRIPTION_CERT_SLUGS.has(slug ?? '')
